import useTrackRendered from '~/hooks/common/telemetry/useTrackRendered';
import useScrollPosition from '~/hooks/vdp/cta/useScrollPosition';

const EXPERIMENT = 'car-merch-ui-vdp-miu-miu-standards-and-150-inspection';
const SCROLL_DEPTH = 1500;

export default function useTrackMiuInspectionRendered(): void {
  const scrollPosition = useScrollPosition();

  useTrackRendered(EXPERIMENT, scrollPosition >= SCROLL_DEPTH);
}
